import{Container as r}from"inversify";import{initCookies as n}from"./init-cookies.js";import{initNetworkService as t}from"./init-network-service.js";const e=(o=null)=>{const i=new r;return n(i),t(i),o&&o(i),i};export{e as initDiContainer};
